import React from "react"
import {FieldViewProps} from "../../../../render/view"
import PropertyGray from "../../../../../gd-components/properties/property-gray/property-gray"

export default function FieldTaskId_ViewProperty(props: FieldViewProps) {

    const value = props.field.getViewValue(props.model)

    return <PropertyGray className={props.className} icon="i5-id m-t-2" value={value}/>
}
